export type FeatureFlagContext = {
  userId: number | null;
  groupIds: number[];
  salespointId: number | null;
};

export type FeatureFlagDefinition = {
  description: string;
  removedBy?: string | null;
  /** Кому фича доступна, у того она сначала выключена: пользователь включает её сам */
  optIn?: boolean;
  enabled: (ctx: FeatureFlagContext) => boolean;
};

export const defineFeatureFlag = (flag: FeatureFlagDefinition): FeatureFlagDefinition => flag;
